import styled from '@emotion/styled';
import { Box, BoxProps, createPolymorphicComponent } from '@mantine/core';

const _TableViewContent = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 0px;
  overflow: auto;

  /* Highlight the actual grid cell */
  .rdg-cell.highlighted-cell {
    background-color: #fff8b3 !important; /* softer yellow */
    box-shadow: inset 0 0 0 2px #ff9800; /* border-like inset */
    font-weight: 600;
  }
`;

export const TableViewContent = createPolymorphicComponent<'div', BoxProps>(
  _TableViewContent
);
